/* eslint-disable */
// SalesEstimator engine — the former public/calculators/sales-estimator.html
// script, unchanged except that DOM lookups are scoped to `root`, the parent
// postMessage calls go through `hooks.post`, and the cpg* bridge is returned
// instead of living on window. Inline handlers in the markup / templates
// are exposed on window while mounted.
export function mountSalesEstimator(root, hooks) {
  const st = {};
  const bridge = {};
  const docListeners = [];
  const onDoc = (t, f) => { document.addEventListener(t, f); docListeners.push([t, f]); };

const $=id=>root.querySelector('#'+CSS.escape(id));
const escAttr=v=>String(v??'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
const fmt=n=>n==null?'—':'$'+Math.round(n).toLocaleString('en-US');
const fmtPct=n=>(n*100).toFixed(1)+'%';
const fmtDec=(n,d=2)=>'$'+n.toFixed(d);

// ── TAB SYSTEM ──────────────────────────────────────────────────────────────
const TAB_ORDER=['welcome','opening','cogs','online','retail','distrib','opex','staff','finance','results'];
function showTab(id){
  root.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('active'));
  root.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));
  $('tab-'+id).classList.add('active');
  root.querySelectorAll('.tab-btn').forEach(b=>{
    if(b.getAttribute('onclick')===`showTab('${id}')`) b.classList.add('active');
  });
  const idx=TAB_ORDER.indexOf(id);
  const pct=Math.max(10,(idx/(TAB_ORDER.length-1))*100).toFixed(0);
  $('progressFill').style.width=pct+'%';
  hooks.scrollTop();
}

// ── TOOLTIP ──────────────────────────────────────────────────────────────────
let tipTimeout;
function tip(btn,title,text){
  const p=$('tipPopup');
  $('tipTitle').textContent=title; $('tipBody').textContent=text;
  const r=btn.getBoundingClientRect();
  let top=r.bottom+8, left=r.left-10;
  if(left+310>window.innerWidth) left=window.innerWidth-320;
  if(top+180>window.innerHeight) top=r.top-180;
  p.style.top=top+'px'; p.style.left=left+'px'; const pr=p.getBoundingClientRect(); p.style.top=(2*top-pr.top)+'px'; p.style.left=(2*left-pr.left)+'px';
  p.classList.add('visible');
  clearTimeout(tipTimeout);
  tipTimeout=setTimeout(()=>p.classList.remove('visible'),6000);
}
onDoc('click',e=>{if(!e.target.classList.contains('info-btn'))$('tipPopup').classList.remove('visible');});

// ── STATE ────────────────────────────────────────────────────────────────────
let retailRamp='slow', distribGrowth='none', distribLaunch=3;

// ── DATA ─────────────────────────────────────────────────────────────────────
let opexData=[
  {label:'Offices & Rates',annual:0},
  {label:'Warehousing & Courier',annual:0},
  {label:'Telephones & Internet',annual:0},
  {label:'Insurance',annual:0},
  {label:'Stationery & Post',annual:0},
  {label:'Management Fees',annual:0},
  {label:'Website & Online Costs',annual:0},
  {label:'Accountancy Costs',annual:0},
  {label:'Legal & Professional Fees',annual:0},
  {label:'Travel & Subsistence',annual:0},
  {label:'R&D / NPD / Start-up',annual:0},
  {label:'Sundry Expenses',annual:0},
  {label:'Bank Charges',annual:0},
  {label:'Software Services',annual:0},
  {label:'Agency / Marketing',annual:0},
];
let staffData=[
  {role:'Enter Role',salary:0,count:1},
];
let financeData=[
  {label:'Enter Funding Source',type:'equity',amount:0,rate:0,month:1},
];

// ── RENDER TABLES ─────────────────────────────────────────────────────────────
function renderOpex(){
  $('opexBody').innerHTML=opexData.map((r,i)=>`
    <tr>
      <td><input class="inline-input" value="${escAttr(r.label)}" onchange="opexData[${i}].label=this.value"></td>
      <td><input class="inline-num" type="number" value="${r.annual}" min="0" step="1000" onchange="opexData[${i}].annual=parseFloat(this.value)||0;calculate()"></td>
      <td style="color:var(--mist)">${fmt(r.annual/12)}</td>
      <td><button class="remove-btn" onclick="opexData.splice(${i},1);renderOpex();calculate()">✕</button></td>
    </tr>`).join('');
  calculate();
}
function addOpexRow(){opexData.push({label:'New Expense',annual:0});renderOpex();}

function renderStaff(){
  $('staffBody').innerHTML=staffData.map((r,i)=>`
    <tr>
      <td><input class="inline-input" value="${escAttr(r.role)}" onchange="staffData[${i}].role=this.value"></td>
      <td><input class="inline-num" type="number" value="${r.salary}" min="0" step="500" onchange="staffData[${i}].salary=parseFloat(this.value)||0;calculate()"></td>
      <td><input class="inline-num" type="number" value="${r.count}" min="0" max="20" step="1" style="width:60px" onchange="staffData[${i}].count=parseInt(this.value)||0;calculate()"></td>
      <td>${fmt(r.salary*r.count)}</td>
      <td><button class="remove-btn" onclick="staffData.splice(${i},1);renderStaff();calculate()">✕</button></td>
    </tr>`).join('');
  calculate();
}
function addStaffRow(){staffData.push({role:'New Role',salary:5000,count:1});renderStaff();}

function renderFinance(){
  $('financeBody').innerHTML=financeData.map((r,i)=>`
    <tr>
      <td><input class="inline-input" value="${escAttr(r.label)}" onchange="financeData[${i}].label=this.value"></td>
      <td><select class="inline-sel" onchange="financeData[${i}].type=this.value;calculate()">
        <option value="equity" ${r.type==='equity'?'selected':''}>Equity</option>
        <option value="loan" ${r.type==='loan'?'selected':''}>Loan</option>
        <option value="director" ${r.type==='director'?'selected':''}>Director</option>
        <option value="grant" ${r.type==='grant'?'selected':''}>Grant</option>
      </select></td>
      <td><input class="inline-num" type="number" value="${r.amount}" min="0" step="10000" onchange="financeData[${i}].amount=parseFloat(this.value)||0;calculate()"></td>
      <td><input class="inline-num" type="number" value="${r.rate}" min="0" max="30" step="0.5" style="width:52px" onchange="financeData[${i}].rate=parseFloat(this.value)||0"></td>
      <td><input class="inline-num" type="number" value="${r.month}" min="1" max="24" step="1" style="width:52px" onchange="financeData[${i}].month=parseInt(this.value)||1"></td>
      <td><button class="remove-btn" onclick="financeData.splice(${i},1);renderFinance();calculate()">✕</button></td>
    </tr>`).join('');
  calculate();
}
function addFinanceRow(){financeData.push({label:'New Source',type:'equity',amount:0,rate:0,month:1});renderFinance();}

// ── TOGGLES ───────────────────────────────────────────────────────────────────
function bindToggle(id,cb){
  $(id).querySelectorAll('.toggle-btn').forEach(btn=>{
    btn.addEventListener('click',()=>{
      $(id).querySelectorAll('.toggle-btn').forEach(b=>b.classList.remove('active'));
      btn.classList.add('active'); cb(btn.dataset.val);
    });
  });
}
bindToggle('retailRampToggle',v=>{retailRamp=v;calculate();});
bindToggle('distribGrowthToggle',v=>{distribGrowth=v;calculate();});
bindToggle('distribLaunchToggle',v=>{distribLaunch=parseInt(v);calculate();});
bindToggle('horizonToggle',()=>calculate());

// ── RANGES ────────────────────────────────────────────────────────────────────
function bindRange(id,dId,fn){
  const el=$(id),d=$(dId);
  const u=()=>{
    d.textContent=fn(parseFloat(el.value));
    el.style.setProperty('--val',((parseFloat(el.value)-parseFloat(el.min))/(parseFloat(el.max)-parseFloat(el.min))*100).toFixed(1)+'%');
  };
  el.addEventListener('input',()=>{u();calculate();}); u();
}
bindRange('engagementRate','engagementRateVal',v=>v.toFixed(1)+'%');
bindRange('conversionRate','conversionRateVal',v=>v.toFixed(2)+'%');
bindRange('retentionRate','retentionRateVal',v=>v.toFixed(0)+'%');

// ── CALCULATE ─────────────────────────────────────────────────────────────────
function calculate(){
  const cpu=['cogs_ingredients','cogs_packaging','cogs_labour','cogs_freight','cogs_qa','cogs_overhead'].reduce((s,id)=>s+(parseFloat($(id).value)||0),0);
  const oP=parseFloat($('onlinePrice').value)||0;
  const wP=parseFloat($('wholesalePrice').value)||0;
  const dP=parseFloat($('distribPrice').value)||0;
  const uPC=parseFloat($('unitsPerCase').value)||12;

  $('cogs_total_display').innerHTML=`<span><strong>Total COGS / Unit</strong></span><span><strong>${fmtDec(cpu)}</strong></span>`;
  const sg=(pId,aId,gm,diff,sfx)=>{const e=$(pId);e.textContent=fmtPct(gm);e.className='margin-pct '+(gm>0.4?'good':'warn');$(aId).textContent=fmtDec(diff)+' '+sfx;};
  sg('gm_online','gm_online_amt',oP>0?(oP-cpu)/oP:0,oP-cpu,'/ unit');
  sg('gm_wholesale','gm_wholesale_amt',wP>0?(wP-cpu)/wP:0,wP-cpu,'/ case');
  sg('gm_distrib','gm_distrib_amt',dP>0?(dP-cpu)/dP:0,dP-cpu,'/ case');
  $('ltv_val').textContent=fmt(oP*0.65*6);
  $('cac_val').textContent=fmt(oP*0.65*2);

  // Opening position
  const ca=((parseFloat($('op_cash').value)||0)+(parseFloat($('op_stock').value)||0)+(parseFloat($('op_debtors').value)||0));
  const fa=((parseFloat($('op_it').value)||0)+(parseFloat($('op_plant').value)||0)+(parseFloat($('op_intangibles').value)||0)+(parseFloat($('op_ip').value)||0));
  const creds=parseFloat($('op_creditors').value)||0;
  const shF=(parseFloat($('op_shareholder').value)||0)+(parseFloat($('op_director').value)||0)+(parseFloat($('op_ltloans').value)||0);
  const netA=ca+fa-creds, bal=netA-shF;
  $('cur_assets_total').innerHTML=`<span>Current Asset Total</span><span>${fmt(ca)}</span>`;
  $('fix_assets_total').innerHTML=`<span>Fixed Asset Total</span><span>${fmt(fa)}</span>`;
  const bc=$('balance_check'), ok=Math.abs(bal)<1;
  bc.className='sub-total '+(ok?'ok':'err');
  bc.innerHTML=`<span>Balance Check ${ok?'✓':'⚠'}</span><span>${fmt(Math.abs(bal))}</span>`;
  const bn=$('balance_note');
  if(!ok){bn.style.display='';bn.textContent=`Net assets (${fmt(netA)}) ≠ shareholders' funds (${fmt(shF)}). Adjust to zero.`;}
  else bn.style.display='none';

  const totOpexAnn=opexData.reduce((s,r)=>s+(r.annual||0),0);
  $('opex_total').textContent=fmt(totOpexAnn); $('opex_monthly').textContent=fmt(totOpexAnn/12);
  const totPayMo=staffData.reduce((s,r)=>s+r.salary*r.count,0);
  $('payroll_monthly').textContent=fmt(totPayMo); $('payroll_annual').textContent=fmt(totPayMo*12);
  const totEq=financeData.filter(r=>r.type==='equity').reduce((s,r)=>s+(r.amount||0),0);
  const totDbt=financeData.filter(r=>r.type!=='equity').reduce((s,r)=>s+(r.amount||0),0);
  $('fin_equity').textContent=fmt(totEq); $('fin_debt').textContent=fmt(totDbt);
  const totOpexInc=totOpexAnn+totPayMo*12, opexMo=totOpexInc/12;

  const fol=parseFloat($('followers').value)||0;
  const engR=parseFloat($('engagementRate').value)/100;
  const convR=parseFloat($('conversionRate').value)/100;
  const retR=parseFloat($('retentionRate').value)/100;
  const inflF=parseFloat($('influencerFollowers').value)||0;
  const v20=parseFloat($('velocity20').value)||4, v80=parseFloat($('velocity80').value)||2;
  const sY1=parseFloat($('yr1StoresEnd').value)||0, sY2=parseFloat($('yr2StoresEnd').value)||0;
  const palS=parseFloat($('palletsStart').value)||0, palP=parseFloat($('palletsPeak').value)||0;
  const cPP=parseFloat($('casesPerPallet').value)||156;
  const newCM=(fol+inflF*0.5)*engR*convR;
  const ramps={slow:[0,.02,.05,.07,.10,.15,.20,.26,.30,.35,.42,.50],medium:[0,.03,.08,.13,.19,.28,.38,.50,.62,.72,.85,1],fast:[.05,.12,.22,.35,.50,.65,.75,.83,.88,.92,.96,1]};
  const ramp=ramps[retailRamp];

  // Horizon: 2, 3, or 5 years. Beyond Y2, apply a compound growth rate.
  const horizonEl=$('horizonToggle');
  const activeBtn=horizonEl?horizonEl.querySelector('.toggle-btn.active'):null;
  const horizon=activeBtn?parseInt(activeBtn.dataset.val)||3:3;
  const beyondGrowth=(parseFloat($('beyondY2Growth').value)||0)/100;
  const beyondWrap=$('beyondY2Wrap');
  if(beyondWrap) beyondWrap.style.display=horizon>2?'flex':'none';

  // Build stores + pallets arrays for each year in the horizon.
  // Y1: ramp from 0 to sY1. Y2: ramp from sY1 to sY2. Y3+: compound the beyondGrowth rate.
  const gM={none:1,moderate:1.5,aggressive:2}[distribGrowth];
  const yearlyStoresEnd=[sY1,sY2];
  for(let y=3;y<=horizon;y++){
    yearlyStoresEnd.push(Math.round(yearlyStoresEnd[y-2]*(1+beyondGrowth)));
  }
  const yr1S=ramp.map(r=>Math.round(r*sY1));
  const yr1P=Array.from({length:12},(_,i)=>{if(i<(distribLaunch-1))return 0;const p=(i-(distribLaunch-1))/Math.max(1,11-(distribLaunch-1));return Math.round(palS+p*(palP-palS));});
  const yearsStores=[yr1S];
  const yearsPallets=[yr1P];
  let prevPalletsPerMonth=yr1P; // for Y2, ramp is: peak-of-prev-year -> peak * gM * (1+beyondGrowth)^(y-2)
  for(let y=2;y<=horizon;y++){
    const startStores=yearlyStoresEnd[y-2], endStores=yearlyStoresEnd[y-1];
    const yrS=ramp.map(r=>Math.round(startStores+r*(endStores-startStores)));
    yearsStores.push(yrS);
    // Pallets: Y2 uses gM (existing user input). Y3+ compounds beyondGrowth on top.
    const palletsMult=y===2?gM:gM*Math.pow(1+beyondGrowth,y-2);
    const yrP=yr1P.map(p=>Math.round(p*palletsMult));
    yearsPallets.push(yrP);
  }

  const monthLabelsY1=['Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar','Apr','May','Jun'];
  const monthLabelsCal=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const Y1M=monthLabelsY1;
  const yearLabels=[Y1M];
  for(let y=2;y<=horizon;y++) yearLabels.push(monthLabelsCal);

  let pN=0,pR=0; const results=[];
  const cm=(month,stores,pallets)=>{
    const ret=(pN+pR)*retR, totC=newCM+ret;
    const oR=totC*oP, oC=totC*cpu; pN=newCM; pR=ret;
    const t20=Math.round(stores*.2),b80=stores-t20;
    const rCas=t20*v20+b80*v80, rR=rCas*wP, rC=rCas*uPC*cpu;
    const dCas=pallets*cPP, dR=dCas*dP, dC=dCas*cpu;
    return{month,onlineRev:oR,retailRev:rR,distribRev:dR,totalRev:oR+rR+dR,totalCogs:oC+rC+dC};
  };
  for(let y=0;y<horizon;y++){
    yearLabels[y].forEach((m,i)=>results.push(cm(m,yearsStores[y][i],yearsPallets[y][i])));
  }
  const sum=(a,k)=>a.reduce((s,r)=>s+(r[k]||0),0);

  // Per-year aggregates
  const perYear=[];
  for(let y=1;y<=horizon;y++){
    const slice=results.slice((y-1)*12,y*12);
    const yR=sum(slice,'totalRev'), yC=sum(slice,'totalCogs'), yG=yR-yC;
    const yOn=sum(slice,'onlineRev'), yRe=sum(slice,'retailRev'), yDi=sum(slice,'distribRev');
    const yEBI=yG-totOpexInc;
    perYear.push({y,R:yR,C:yC,G:yG,On:yOn,Re:yRe,Di:yDi,EBI:yEBI,slice});
  }
  // Keep Y1 (channel breakdown row) accessible under the old names for existing DOM ids
  const y1R=perYear[0].R, y1G=perYear[0].G;
  const y1On=perYear[0].On, y1Re=perYear[0].Re, y1Di=perYear[0].Di;

  const fl=id=>{const e=$(id);if(!e)return;e.classList.add('updating');setTimeout(()=>e.classList.remove('updating'),400);};
  ['kpi_y1_online','kpi_y1_retail','kpi_y1_distrib','kpi_overhead','kpi_equity','kpi_debt','kpi_months'].forEach(fl);

  // Render dynamic per-year KPI grid
  const kpiHost=$('kpiPerYear');
  if(kpiHost){
    kpiHost.innerHTML=perYear.map(py=>{
      const gp=py.G, ebi=py.EBI, gm=py.R>0?(gp/py.R*100).toFixed(1)+'%':'—';
      const ebiTone=ebi>=0?'kpi-positive':'kpi-negative';
      const ebiSub=ebi<0?'⚠ operating loss':'operating profit';
      return `<div class="results-grid-3" data-testid="kpi-year-${py.y}" style="margin-bottom:1px">
        <div class="kpi-cell kpi-accent"><div class="kpi-label">Year ${py.y} Revenue</div><div class="kpi-value">${fmt(py.R)}</div><div class="kpi-sub">12-month total</div></div>
        <div class="kpi-cell"><div class="kpi-label">Year ${py.y} Gross Profit</div><div class="kpi-value kpi-positive">${fmt(gp)}</div><div class="kpi-sub">${gm} gross margin</div></div>
        <div class="kpi-cell kpi-accent"><div class="kpi-label">Year ${py.y} EBITDA</div><div class="kpi-value ${ebiTone}">${fmt(ebi)}</div><div class="kpi-sub">${ebiSub}</div></div>
      </div>`;
    }).join('');
  }

  $('kpi_overhead').textContent=fmt(totOpexInc);
  $('kpi_equity').textContent=fmt(totEq); $('kpi_debt').textContent=fmt(totDbt);
  $('kpi_months').textContent=`${horizon*12}`;
  const horizonSub=$('kpi_horizon_sub'); if(horizonSub) horizonSub.textContent=`${horizon}-year horizon`;
  const chartTitle=$('chartTitle'); if(chartTitle) chartTitle.textContent=`Monthly Revenue Breakdown — ${horizon}-year projection`;
  const resultsTitle=$('resultsTitle'); if(resultsTitle) resultsTitle.textContent=`${horizon*12}-Month Financial Model`;
  $('kpi_y1_online').textContent=fmt(y1On); $('kpi_y1_retail').textContent=fmt(y1Re); $('kpi_y1_distrib').textContent=fmt(y1Di);
  $('kpi_y1_online_pct').textContent=y1R>0?fmtPct(y1On/y1R)+' of Y1':'0%';
  $('kpi_y1_retail_pct').textContent=y1R>0?fmtPct(y1Re/y1R)+' of Y1':'0%';
  $('kpi_y1_distrib_pct').textContent=y1R>0?fmtPct(y1Di/y1R)+' of Y1':'0%';

  const maxR=Math.max(...results.map(r=>r.totalRev),1),H=140;
  $('barChart').innerHTML=results.map((r,i)=>{
    const yr=Math.floor(i/12)+1;
    return`<div class="bar-group" title="Y${yr} ${r.month}: ${fmt(r.totalRev)}">
      <div class="bar-stack">
        <div class="bar-seg online"  style="height:${(r.onlineRev/maxR*H).toFixed(1)}px"></div>
        <div class="bar-seg retail"  style="height:${(r.retailRev/maxR*H).toFixed(1)}px"></div>
        <div class="bar-seg distrib" style="height:${(r.distribRev/maxR*H).toFixed(1)}px"></div>
      </div>
      <div class="bar-month">${yr}${r.month.slice(0,3)}</div>
    </div>`;
  }).join('');

  const z=v=>v<1?`<span class="zero">—</span>`:fmt(v);
  let html='';
  const mkRows=(rows,labels,year,ytR,ytC,ytG,ytOn,ytRe,ytDi)=>{
    const bg=year===1?'var(--ink)':(year===2?'var(--forest)':(year===3?'#3a5a44':(year===4?'#495a3a':'#5a4a3a')));
    const col=year===1?'var(--accent-on-dark)':'#ffffff';
    const mStart=(year-1)*12+1, mEnd=year*12;
    html+=`<tr><td colspan="10" style="background:${bg};color:${col};font-family:var(--font-mono);font-size:0.62rem;letter-spacing:0.1em;text-transform:uppercase;padding:0.38rem 0.75rem;">Year ${year} — Month ${mStart}–${mEnd}</td></tr>`;
    rows.forEach((r,i)=>{
      const gp=r.totalRev-r.totalCogs,eb=gp-opexMo;
      html+=`<tr><td>${labels[i]}</td><td>${z(r.onlineRev)}</td><td>${z(r.retailRev)}</td><td>${z(r.distribRev)}</td><td><strong>${z(r.totalRev)}</strong></td><td>${z(r.totalCogs)}</td><td class="${gp>0?'pos':''}">${z(gp)}</td><td>${r.totalRev>0?(gp/r.totalRev*100).toFixed(1)+'%':'—'}</td><td style="color:var(--mist)">${fmt(opexMo)}</td><td class="${eb>0?'pos':'neg'}">${fmt(eb)}</td></tr>`;
    });
    const tG=ytR-ytC,tE=tG-totOpexInc;
    html+=`<tr class="tot-row"><td>Y${year} Total</td><td>${fmt(ytOn)}</td><td>${fmt(ytRe)}</td><td>${fmt(ytDi)}</td><td><strong>${fmt(ytR)}</strong></td><td>${fmt(ytC)}</td><td class="pos">${fmt(tG)}</td><td>${ytR>0?(tG/ytR*100).toFixed(1)+'%':'—'}</td><td style="color:var(--mist)">${fmt(totOpexInc)}</td><td class="${tE>0?'pos':'neg'}">${fmt(tE)}</td></tr>`;
  };
  perYear.forEach(py=>{
    mkRows(py.slice,yearLabels[py.y-1],py.y,py.R,py.C,py.G,py.On,py.Re,py.Di);
  });
  $('monthlyTableBody').innerHTML=html;
}

// ── INIT ──────────────────────────────────────────────────────────────────────
renderOpex(); renderStaff(); renderFinance();
// ── CPG Bridge: parent-page save/hydrate helpers ─────────────────────────────
// Exposed to the parent React wrapper (Tools.jsx::ToolEmbed) so the parent can
// snapshot every input into a Project draft and later re-hydrate a saved
// draft/result back into this iframe. The iframe UI itself owns the
// **Save Draft** button (placed next to Next Step on every step tab) —
// clicking it posts a message up to the parent which opens the shared
// Save-to-Projects modal. Save Result stays in the parent toolbar because
// it only applies to the Results tab which already has its own layout.
//
// State surface: every <input> with an id, plus the currently-active tab.
bridge.cpgCollectState = function () {
  var out = {};
  root.querySelectorAll('input[id]').forEach(function (el) {
    if (el.type === 'checkbox' || el.type === 'radio') {
      out[el.id] = !!el.checked;
    } else {
      out[el.id] = el.value;
    }
  });
  var active = root.querySelector('.tab-panel.active');
  out.__activeTab = active ? active.id.replace(/^tab-/, '') : 'welcome';
  return out;
};

bridge.cpgApplyState = function (snap) {
  if (!snap || typeof snap !== 'object') return;
  Object.keys(snap).forEach(function (id) {
    if (id.indexOf('__') === 0) return; // skip meta keys
    var el = $(id);
    if (!el || el.tagName !== 'INPUT') return;
    if (el.type === 'checkbox' || el.type === 'radio') {
      el.checked = !!snap[id];
    } else {
      el.value = snap[id];
    }
  });
  try { calculate(); } catch (e) { /* recalc after hydrate — safe to ignore if not ready */ }
  // Hydrating from a snapshot counts as "dirty" so the Save Draft
  // button is enabled immediately on re-open (matches what the founder
  // expects when they're continuing a saved draft).
  st.__cpgDirty = true;
  bridge.cpgRefreshSaveDraftEnabled && bridge.cpgRefreshSaveDraftEnabled();
  if (snap.__activeTab) {
    try { showTab(snap.__activeTab); } catch (e) { /* fall through */ }
  }
};

// View-only mode: parent flips this to true when a `result` snapshot is
// loaded from Projects. We disable every input + hide the Welcome CTA
// so nothing is mutable, but keep tab navigation working so founders
// can flip through the saved model. Save Draft buttons are hidden.
bridge.cpgSetViewOnly = function (readOnly) {
  root.querySelectorAll('input, select, textarea').forEach(function (el) {
    if (readOnly) {
      el.setAttribute('data-cpg-locked', '1');
      el.disabled = true;
    } else if (el.getAttribute('data-cpg-locked') === '1') {
      el.removeAttribute('data-cpg-locked');
      el.disabled = false;
    }
  });
  root.classList.toggle('cpg-view-only', !!readOnly);
  st.__cpgViewOnly = !!readOnly;
  bridge.cpgRefreshSaveDraftEnabled && bridge.cpgRefreshSaveDraftEnabled();
};

// Dirty-state + Save Draft button injection.
// Save Draft rules:
//   • Welcome + Results tabs never get one.
//   • Every other tab gets a Save Draft button beside its Next-Step button.
//   • Button starts disabled and only enables once the founder has typed
//     into ANY input on ANY tab (or hydrated from a saved snapshot).
//   • Clicking posts `{__cpg:'save-draft'}` to the parent which opens
//     the shared Save-to-Projects modal.
st.__cpgDirty = false;
st.__cpgViewOnly = false;
bridge.cpgRefreshSaveDraftEnabled = function () {
  root.querySelectorAll('.cpg-save-draft-btn').forEach(function (b) {
    var isResult = b.getAttribute('data-cpg-save-mode') === 'result';
    // Save Result: always enabled on the Results tab (a projected result
    // exists as soon as the tool loads — no dirty-typing requirement).
    // Save Draft: only enables once the founder has typed on any tab.
    var enabled = isResult
      ? !st.__cpgViewOnly
      : (st.__cpgDirty && !st.__cpgViewOnly);
    b.disabled = !enabled;
    b.style.display = st.__cpgViewOnly ? 'none' : '';
    b.title = isResult
      ? 'Save this projection + final result to a Project folder — opens view-only when re-opened.'
      : (enabled
          ? 'Save your progress to a Project folder — you can continue from where you left off.'
          : 'Start filling in this step to enable Save Draft.');
  });
};

(function injectSaveDraftButtons () {
  // Skip the Welcome tab (introduction). Every OTHER tab (including
  // Results) gets a save button appended to its page-nav row:
  //   • Step tabs (opening…finance): "Save Draft"  → posts 'save-draft'
  //   • Results tab:                   "Save Result" → posts 'save-result'
  // Both share the same .page-nav-btn.save styling for a consistent look.
  root.querySelectorAll('.tab-panel').forEach(function (panel) {
    var slug = (panel.id || '').replace(/^tab-/, '');
    if (slug === 'welcome') return;
    var nav = panel.querySelector('.page-nav');
    if (!nav) return;
    var isResult = (slug === 'results');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'page-nav-btn save cpg-save-draft-btn';
    btn.setAttribute('data-testid', isResult ? 'iframe-save-result' : 'iframe-save-draft');
    btn.textContent = isResult ? 'Save Result' : 'Save Draft';
    btn.setAttribute('data-cpg-save-mode', isResult ? 'result' : 'draft');
    // Save Result: enabled by default (Results tab always has a valid model).
    // Save Draft: starts disabled — cpgRefreshSaveDraftEnabled will flip
    // it on once the founder types on any tab.
    btn.disabled = !isResult;
    btn.title = isResult
      ? 'Save this projection + final result to a Project folder — opens view-only when re-opened.'
      : 'Start filling in this step to enable Save Draft.';
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      try {
        hooks.post(
          { __cpg: isResult ? 'save-result' : 'save-draft' },
          '*'
        );
      } catch (e) { /* cross-origin — ignore */ }
    });
    nav.appendChild(btn);
  });
  // Global input listener → flip the dirty flag the first time anyone types.
  root.addEventListener('input', function (ev) {
    if (!ev.target || ev.target.tagName !== 'INPUT') return;
    if (st.__cpgDirty) return;
    st.__cpgDirty = true;
    bridge.cpgRefreshSaveDraftEnabled();
  });
})();

// Emits the currently-active tab id whenever the founder navigates so the
// parent React wrapper can decide when to show "Save Result" (only on
// the final results tab). Uses a lightweight custom event; the parent
// polls the active tab via cpgCollectState() but this makes UI feel snappy.
(function () {
  var _showTab = showTab;
  showTab = function (id) {
    _showTab(id);
    try { hooks.post({ __cpg: 'tab', tab: id }, '*'); } catch (e) { /* cross-origin — ignore */ }
  };
})();


  const GLOBALS = { showTab: (...a) => showTab(...a), tip, calculate, financeData, opexData, staffData, addFinanceRow, addOpexRow, addStaffRow, renderFinance, renderOpex, renderStaff };
  Object.assign(window, GLOBALS);
  bridge.destroy = () => {
    docListeners.forEach(([t, f]) => document.removeEventListener(t, f));
    Object.keys(GLOBALS).forEach((k) => { if (window[k] === GLOBALS[k]) delete window[k]; });
  };
  return bridge;
}
